export default __webpack_public_path__ + "static/media/AtkinsonHyperlegibleMono-Bold.e0f2f9be.woff2";